const Loader = () => {
    return (
        <div className="loader-backdrop">
            <div className="loader">
                <i className="fa-solid fa-kaaba fa-2xl fa-flip"></i>
            </div>
        </div>
    )
}

export default Loader;